module.exports = __webpack_public_path__ + "img/h_chelsea_main.jpg";